// @ts-nocheck

import { reduce as _reduce } from 'lodash';

import { BasketOddsFromContexts } from '../constants/basket';

// pour le cas d'un betbuilder, le BID est un tableau de { matchId, betId, outcomeId }
const getBetbuilderTriplet = (basketItem) => {
  return basketItem.selectionItems.map(({ matchId, betId, outcomeId, outcomeIds }) => {
    let BID = outcomeId;
    if (outcomeIds) {
      BID = outcomeIds.length === 1 ? outcomeIds[0] : outcomeIds;
    }
    return {
      MID: matchId,
      BEID: betId,
      BID,
    };
  });
};

export const createSingleBetslipSubmitPayload = (
  CV,
  locale,
  validItems,
  isCashout,
  cashoutBetslipId,
  GRRace,
  boom,
  overrideDatas = {},
  isRepeatBet,
) => {
  const T = 1;
  const {
    stake,
    selectedFreebetId,
    selectedBonusId,
    eligibleKLCollectibleId,
    isGRActive,
    isMonopolyActive,
    monopolyCard,
    isBoomActive,
    isFromLineUp,
    missionsParams,
  } = overrideDatas;

  return _reduce(
    validItems,
    (finalData, item) => {
      if (isCashout && cashoutBetslipId && item.cashout) {
        return finalData;
      }

      const finalStake = stake ?? item.stake;
      const A = Math.round(finalStake * 100);
      let BID = item.oddId;
      let B = [{ BID, O: Math.round(item.value * 1000) }];

      if (item.betbuilder) {
        BID = getBetbuilderTriplet(item);
        B = [{ BID, O: Math.round(item.value * 1000), R: item.oddId }];
      }

      const data = { T, A, B, CV, locale };

      const finalSelectedFreebetId = selectedFreebetId ?? item.selectedFreebetId;
      const finalSelectedBonusId = selectedBonusId ?? item.selectedBonusId;
      const finalEligibleKLCollectibleId = eligibleKLCollectibleId ?? item.eligibleKLCollectibleId;
      const finalIsGRActive = isGRActive ?? item.isGRActive;
      const finalIsMonopolyActive = isMonopolyActive ?? item.isMonopolyActive;
      const finalMonopolyCard = monopolyCard ?? item.monopolyCard;
      const finalMissionsParams = missionsParams ?? item.missionsParams;
      const finalIsBoomActive = isBoomActive ?? item.isBoomActive;

      data.F = finalSelectedFreebetId ?? undefined;
      data.BS = finalSelectedBonusId;
      data.KL = finalEligibleKLCollectibleId ?? undefined;
      data.GR = finalIsGRActive ? GRRace : undefined;
      data.MONOPOLY = finalIsMonopolyActive ? finalMonopolyCard : undefined;
      data.BOOM = finalIsBoomActive ? boom : undefined;
      data.MISSION = finalMissionsParams ?? undefined;
      data.CTX = {};

      let hasCTX = false;

      const finalIsFromLineUp = isFromLineUp ?? item.isFromLineUp;
      if (finalIsFromLineUp) {
        data.CTX[BasketOddsFromContexts.LINE_UP] = true;
        hasCTX = true;
      }

      if (isRepeatBet) {
        data.CTX[BasketOddsFromContexts.REPEAT_BET] = true;
        hasCTX = true;
      }

      if (!hasCTX) {
        delete data.CTX;
      }

      if (isCashout) {
        delete data.BOOM;
      }

      finalData.push(data);

      return finalData;
    },
    [],
  );
};

export const createMultipleBetslipSubmitPayload = (
  stake,
  selectedFreebetId,
  validItems,
  isCashout,
  cashoutBetslipId,
  CV,
  locale,
  eligibleBooster,
  selectedBonusId,
  eligibleKLCollectibleId,
  isGRActive,
  GRRace,
  monopolyCard,
  isFromLineUp,
  isRepeatBet,
  isMonopolyActive,
  boom,
  missionsParams,
) => {
  const A = Math.round(stake * 100);
  const F = selectedFreebetId ? selectedFreebetId : undefined;
  const KL = eligibleKLCollectibleId ? eligibleKLCollectibleId : undefined;
  const GR = isGRActive ? GRRace : undefined;
  const MONOPOLY = isMonopolyActive ? monopolyCard : undefined;
  const BOOM = boom;
  const MISSION = missionsParams ?? undefined;

  const multipleBetslipSubmitPayload = [
    (() => {
      const initialPayload = {
        T: 2,
        A,
        B: [],
        F,
        CV,
        locale,
        KL,
        GR,
        MONOPOLY,
        BOOM,
        MISSION,
      };

      initialPayload.CTX = {};

      let hasCTX = false;
      if (isFromLineUp) {
        initialPayload.CTX[BasketOddsFromContexts.LINE_UP] = true;
        hasCTX = true;
      }

      if (isRepeatBet) {
        initialPayload.CTX[BasketOddsFromContexts.REPEAT_BET] = true;
        hasCTX = true;
      }

      if (!hasCTX) {
        delete initialPayload.CTX;
      }

      if (isCashout) {
        delete initialPayload.BOOM;
      }

      return _reduce(
        validItems,
        (finalData, item) => {
          if (isCashout && cashoutBetslipId && item.cashout) {
            return finalData;
          } else {
            if (item.betbuilder) {
              return {
                ...finalData,
                B: [
                  ...finalData.B,
                  {
                    BID: getBetbuilderTriplet(item),
                    O: Math.round(item.value * 1000),
                    R: item.oddId,
                  },
                ],
              };
            }
            return {
              ...finalData,
              B: [
                ...finalData.B,
                {
                  BID: item.oddId,
                  O: Math.round(item.value * 1000),
                },
              ],
            };
          }
        },
        initialPayload,
      );
    })(),
  ];

  if (eligibleBooster && eligibleBooster.boosterId && eligibleBooster.current > 1) {
    multipleBetslipSubmitPayload[0].BO = eligibleBooster.boosterId;
  }

  if (selectedBonusId) {
    multipleBetslipSubmitPayload[0].BS = selectedBonusId;
  }

  if (isCashout && cashoutBetslipId) {
    multipleBetslipSubmitPayload[0].P = cashoutBetslipId;
  }

  return multipleBetslipSubmitPayload;
};

export const createSystemBetslipSubmitPayload = (
  stake,
  systems,
  validItems,
  CV,
  locale,
  eligibleBooster,
  selectedFreebetId,
  isFromLineUp,
  isRepeatBet,
) => {
  const A = Math.round(stake * 100);
  const C = _reduce(
    systems,
    (finalData, item) => {
      if (item.checked) {
        finalData.push({
          P: item.k,
        });
      }
      return finalData;
    },
    [],
  );
  const F = selectedFreebetId ? true : undefined;

  const systemBetslipSubmitPayload = [
    (() => {
      const initialPayload = {
        T: 3,
        A,
        B: [],
        F,
        C,
        CV,
        locale,
      };

      initialPayload.CTX = {};

      let hasCTX = false;
      if (isFromLineUp) {
        initialPayload.CTX[BasketOddsFromContexts.LINE_UP] = true;
        hasCTX = true;
      }

      if (isRepeatBet) {
        initialPayload.CTX[BasketOddsFromContexts.REPEAT_BET] = true;
        hasCTX = true;
      }

      if (!hasCTX) {
        delete initialPayload.CTX;
      }

      return _reduce(
        validItems,
        (finalData, item) => {
          if (item.betbuilder) {
            return {
              ...finalData,
              B: [
                ...finalData.B,
                {
                  BID: getBetbuilderTriplet(item),
                  BK: item.banker,
                  O: Math.round(item.value * 1000),
                  R: item.oddId,
                },
              ],
            };
          }
          return {
            ...finalData,
            B: [
              ...finalData.B,
              {
                BID: item.oddId,
                BK: item.banker,
                O: Math.round(item.value * 1000),
              },
            ],
          };
        },
        initialPayload,
      );
    })(),
  ];
  if (eligibleBooster && eligibleBooster.boosterId && eligibleBooster.boosterGain > 0) {
    systemBetslipSubmitPayload[0].BO = eligibleBooster.boosterId;
  }

  return systemBetslipSubmitPayload;
};
